module.exports = {
  cards: {
    got_it_right: 'Known',
    got_it_wrong: 'Not known',
    zoom_out: 'Reduce',
    zoom_in: 'Enlarge',
  },
  flip: 'Flip',
}
